// extracted by mini-css-extract-plugin
export default {"container":"j2-z"};